import { getMyProjects } from "../api/myProjectsHttpClient"

export const useMyProjectsGrid = () => {

    return { fetchGridData: getMyProjects }
}